import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const events = [
  {
    title: "Legal insights on buying or leasing commercial property.",
    date: "4th December 2025",
    time: "2 PM (UK TIME)",
    duration: "60 mins",
    speaker: "Mr. Rohat Kumbar",
    description: `
      <h5>Thinking about leasing a new office, buying commercial property, or hiring skilled global talent?</h5>
        <p>This webinar gives you the clarity you need to grow with confidence.

Join Mr. Rohat Kumar, Director at Lumine Law, as he simplifies complex legal topics into clear, actionable steps every business owner can follow.</p>
        <h5>Webinar Topics</h5>
        <ul>
          <li>Legal insights on buying or leasing commercial property</li>
          <li>Sponsoring overseas skilled workers</li>
          <li>Date: Thursday, 4th December 2025</li>
          <li>Time: 2:00 PM (UK Time)</li>
          <li>Speaker: Mr. Rohat Kumar, Director – Lumine Law</li>
         
        </ul>
       
    `,
    link: "",
    image: "/assets/images/event-banner/Steve-Allen.png",
  },
];

const EventSlider1 = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    if (events.length <= 1) return;

    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % events.length);
        setFade(true);
      }, 400);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const currentEvent = events[currentIndex];

  
  return (
    <>
      <section className="event-container">
        <div className="container-fluid mt-4">
          <div className="event-slider-container">
            <div className="event-card">
              <div className="event-label">Upcoming Webinar</div>
              <NavLink
                to="/fca-supervision-2009-to-today"
                state={{ event: currentEvent }}
                className={`event-info ${fade ? "fade-in" : "fade-out"}`}
              >
                <div className="event-title">1. Legal insights on buying or leasing commercial property. <br /> 2. Sponsoring overseas skilled workers.</div>
                <div className="event-meta">
                  <span>
                    <strong>Date</strong>: {currentEvent.date}
                  </span>
                  <span className="d-none d-sm-block">|</span>
                  <span>
                    <strong>Time</strong>: {currentEvent.time}
                  </span>
                </div>
              </NavLink>
              <NavLink
                to="/fca-supervision-2009-to-today#webinarRegisterForm"
                state={{ event: currentEvent }}
                className="event-button"
              >
                Register Now
              </NavLink>
            </div>    
          </div>
        </div>
      </section>
    </>
  );
};

export default EventSlider1;
